export default store => {
	store.subscribe(({ type, payload }, state) => {
		// console.log(type, type);
		switch (type) {
			case 'store/setStore':
				// return 12;
				// console.log(type);
		}
	})
}